// src/components/Dashboard.js (sekarang hanya konten overview)
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
// Hapus import MissionManagement jika sudah jadi halaman sendiri
// import MissionManagement from './management/MissionManagement';
import './Dashboard.css'; // CSS spesifik untuk halaman ini jika ada

const API_BASE_URL = 'https://api.pondoknusantara.com/api/admin';

function Dashboard() {
  const auth = useAuth();
  const navigate = useNavigate();
  
  const [appVersion, setAppVersion] = useState(null);
  const [loadingGeneralData, setLoadingGeneralData] = useState(true);
  const [generalError, setGeneralError] = useState('');

  // handleLogout sekarang ada di Header.js, jadi bisa dihapus dari sini
  // const handleLogout = async () => { ... };

  const fetchGeneralData = async (endpoint) => {
    // ... (logika fetchGeneralData tetap sama)
    const token = auth.getToken();
    if (!token) {
      setGeneralError('Authentication token not found.');
      auth.logout(); 
      navigate('/login');
      return null;
    }

    try {
      const response = await fetch(`${API_BASE_URL}${endpoint}`, {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        if (response.status === 401) {
            setGeneralError('Session expired or token is invalid. Please login again.');
            auth.logout(); 
            navigate('/login');
        } else {
            const errData = await response.json();
            throw new Error(errData.message || `Error fetching ${endpoint}: ${response.statusText}`);
        }
        return null;
      }
      const data = await response.json();
      return data;
    } catch (err) {
      console.error(`Error fetching ${endpoint}:`, err);
      setGeneralError(err.message);
      return null;
    }
  };

  useEffect(() => {
    const loadDashboardGeneralData = async () => {
      if (!auth.isLoggedIn) {
        navigate('/login');
        return;
      }
      setLoadingGeneralData(true);
      setGeneralError('');

      const versionData = await fetchGeneralData('/app-version');
      if (versionData) {
        setAppVersion(versionData);
      }
      setLoadingGeneralData(false);
    };

    loadDashboardGeneralData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isLoggedIn, navigate]); // auth.getToken tidak perlu jika tidak berubah sering

  if (loadingGeneralData) {
    return (
      <div className="dashboard-content-area loading-container"> {/* Ganti nama class jika perlu */}
        <p>Loading dashboard overview...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-content-area"> {/* Ganti nama class jika perlu */}
      {/* Header dan Footer sudah di MainLayout */}
      {/* Navigasi sekarang ada di Sidebar.js */}
      
      <h2>Dashboard Overview</h2>

      {generalError && (
        <div className="widget error-widget">
          <h3>Error</h3>
          <p className="error-message">{generalError}</p>
        </div>
      )}

      {appVersion && (
        <div id="app-version" className="widget app-version-widget">
          <h3>Pengaturan Versi Aplikasi (dari Dashboard Overview)</h3>
          <p><strong>Versi Minimum:</strong> {appVersion.minimum_version}</p>
          <p><strong>Versi Terbaru:</strong> {appVersion.latest_version}</p>
          <p><strong>Update Wajib:</strong> {appVersion.update_required ? 'Ya' : 'Tidak'}</p>
          {appVersion.update_url && (
            <div>
              <p><strong>URL Update Android:</strong> <a href={appVersion.update_url.android} target="_blank" rel="noopener noreferrer">{appVersion.update_url.android}</a></p>
              <p><strong>URL Update iOS:</strong> <a href={appVersion.update_url.ios} target="_blank" rel="noopener noreferrer">{appVersion.update_url.ios}</a></p>
            </div>
          )}
        </div>
      )}

      {/* Komponen MissionManagement sudah menjadi halaman sendiri, jadi tidak dirender di sini lagi */}
      {/* <div id="missions" className="management-module">
        <MissionManagement />
      </div> */}
      
      <p>Selamat datang di halaman utama dashboard Anda. Pilih menu dari sidebar untuk mengelola bagian lain.</p>

    </div>
  );
}

export default Dashboard;